import React, { useMemo, useCallback } from 'react';
import { useDataPerDevice } from '../../../hooks';
import styles from './Html.module.scss';

const Html = ({
  html, 
  html_mobile, 
  html_pc, 
  assets,
}) => {
  const { getDataPerDeviceView } = useDataPerDevice();

  const innerHtml = useMemo(() => {
    return getDataPerDeviceView(html_mobile, html_pc, html) || '';
  }, [getDataPerDeviceView, html_mobile, html_pc, html]);

  const resolvedAssets = useMemo(() => assets || null, [assets]);

  const applyAssets = useCallback((markup) => {
    if (!markup || !resolvedAssets) {
      return markup;
    }

    return Object.entries(resolvedAssets).reduce((acc, [token, assetUrl]) => {
      if (!token || !assetUrl) {
        return acc;
      }

      const escapedToken = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return acc.replace(new RegExp(escapedToken, 'g'), assetUrl);
    }, markup);
  }, [resolvedAssets]);

  const innerHtmlWithAssets = useMemo(() => applyAssets(innerHtml), [innerHtml, applyAssets]);

  if (!innerHtmlWithAssets) {
    return null;
  }

  return <div className={styles.container} dangerouslySetInnerHTML={{ __html: innerHtmlWithAssets}} />;
};

export default Html;
